import(/* webpackMode: "eager", webpackExports: ["LoadingOverlay"] */ "/vercel/path0/node_modules/@mantine/core/esm/components/LoadingOverlay/LoadingOverlay.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["Box"] */ "/vercel/path0/node_modules/@mantine/core/esm/core/Box/Box.mjs");
